export const getShortInitials = (name?: string) => {
  if (!name) {
    return ''
  }

  return name
    .split(' ')
    .filter((word) => word.length > 0)
    .map((word, index) => {
      if (index < 2) {
        return word[0].toUpperCase()
      }
      return ''
    })
    .join('')
}
